var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "checkbox-container",
    class: _vm.checkboxClass
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  }), _c('span', {
    staticClass: "container-align",
    class: _vm.disabled ? 'disabled' : ''
  }, [_c('span', {
    staticClass: "checkmark",
    class: _vm.value ? 'checked' : ''
  }, [_c('CheckIcon', {
    attrs: {
      "size": 14,
      "fillColor": "white"
    }
  })], 1), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.label))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };